// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1ywbtcf0 {
  background-image: var(--background-image-mobile);
  background-repeat: no-repeat;
  background-size: 105px;
  background-position: 100%;
  max-width: 1200px;
}
._1ywbtcf1 {
  display: block;
  margin: auto;
  padding-bottom: 21px;
  width: auto;
}
._1ywbtcf2 {
  max-width: 50%;
  width: 50%;
}
._1ywbtcf3 {
  max-width: 100%;
}
@media screen and (min-width: 768px) {
  ._1ywbtcf0 {
    background-image: var(--background-image-desktop);
    background-size: 240px;
  }
  ._1ywbtcf1 {
    padding-bottom: 0;
    width: 100%;
  }
  ._1ywbtcf2 {
    width: 100%;
  }
  ._1ywbtcf3 {
    padding-bottom: 0;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,iDAAiD;IACjD,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF","sourcesContent":["._1ywbtcf0 {\n  background-image: var(--background-image-mobile);\n  background-repeat: no-repeat;\n  background-size: 105px;\n  background-position: 100%;\n  max-width: 1200px;\n}\n._1ywbtcf1 {\n  display: block;\n  margin: auto;\n  padding-bottom: 21px;\n  width: auto;\n}\n._1ywbtcf2 {\n  max-width: 50%;\n  width: 50%;\n}\n._1ywbtcf3 {\n  max-width: 100%;\n}\n@media screen and (min-width: 768px) {\n  ._1ywbtcf0 {\n    background-image: var(--background-image-desktop);\n    background-size: 240px;\n  }\n  ._1ywbtcf1 {\n    padding-bottom: 0;\n    width: 100%;\n  }\n  ._1ywbtcf2 {\n    width: 100%;\n  }\n  ._1ywbtcf3 {\n    padding-bottom: 0;\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
